import {
  mapFromInternalAuditAiAuditReportLink,
  mapFromInternalAuditAiAuditStatus,
  mapFromInternalAuditConclusionSuggestion,
  mapFromInternalAuditControlAuditResult,
} from 'mappings/internalAuditAiAuditMapping';
import {
  mapFromInternalAuditExecution,
  mapFromInternalAuditProcedureSuggestions,
  mapFromInternalAuditScopeAssessment,
  mapFromInternalAuditTaskExecution,
} from 'mappings/internalAuditExecutionMappings';
import {
  mapFromInternalAuditCriteriaApplyResult,
  mapFromInternalAuditCriteriaPreview,
  mapFromInternalAuditImprovement,
  mapFromInternalAuditImprovementAnalysis,
  mapFromInternalAuditImprovementResult,
  mapToInternalAuditCriterionDraft,
  mapToInternalAuditImprovementProposal,
} from 'mappings/internalAuditImprovementMappings';
import {
  mapFromAuditMeetingAvailability,
  mapFromInternalAudit,
  mapFromInternalAuditSaveAsTemplateResult,
  mapFromInternalAudits,
  mapToInternalAudit,
  mapToInternalAuditUsers,
} from 'mappings/internalAuditMappings';
import {
  mapFromInternalAuditMonitoringSource,
  mapFromInternalAuditMonitoringUpgradePreview,
  mapFromInternalAuditMonitoringUpgradeResult,
  mapToInternalAuditMonitoringUpgradePreviewRequest,
  mapToInternalAuditMonitoringUpgradeRequest,
} from 'mappings/internalAuditMonitoringUpgradeMappings';
import { mapFromInternalAuditReportSettings } from 'mappings/internalAuditReportSettingsMappings';
import {
  mapFromInternalAuditScope,
  mapFromInternalAuditScopeCandidates,
  mapFromInternalAuditScopeIndex,
  mapFromInternalAuditScopeItems,
  mapFromInternalAuditScopeSuggestions,
} from 'mappings/internalAuditScopeMappings';
import {
  mapFromInternalAuditSchedules,
  mapFromInternalAuditTemplate,
  mapFromInternalAuditTemplates,
  mapToInternalAuditTemplate,
} from 'mappings/internalAuditTemplateMappings';
import { mapFromResourceLink, mapFromResourceLinks } from 'mappings/linkMapping';
import { mapFromTask, mapFromTasks } from 'mappings/taskMapping';
import { mapFromTaskTypeForm } from 'mappings/taskTypeMapping';
import IdListDTO from 'models/dto/IdListDTO';
import {
  InternalAuditAiAuditReportLinkDTO,
  InternalAuditAiAuditStartDTO,
  InternalAuditAiAuditStatusDTO,
  InternalAuditConclusionSuggestionDTO,
  InternalAuditControlAuditResultDTO,
} from 'models/dto/internalAuditAiAuditDTO';
import InternalAuditDTO, {
  InternalAuditAssessmentDTO,
  InternalAuditLinkDTO,
  InternalAuditMeetingAvailabilityDTO,
  InternalAuditReportDocumentStatusDTO,
  InternalAuditReportUpdateDTO,
  InternalAuditSaveAsTemplateResultDTO,
  InternalAuditTeamPermissionDTO,
  InternalAuditTeamPermissionRequestDTO,
  InternalAuditTransitionDTO,
} from 'models/dto/internalAuditDTO';
import InternalAuditExecutionDTO, {
  InternalAuditExecutionAssignDTO,
  InternalAuditExecutionItemsDTO,
  InternalAuditExecutionOrderItemDTO,
  InternalAuditExecutionPlanDTO,
  InternalAuditExecutionReorderDTO,
  InternalAuditFindingsPrecheckDTO,
  InternalAuditProcedureSuggestionDTO,
  InternalAuditScopeAssessmentDTO,
  InternalAuditScopeItemKeyDTO,
  InternalAuditTaskExecutionDTO,
  InternalAuditTaskNavigationDTO,
  InternalAuditTaskResultDTO,
} from 'models/dto/internalAuditExecutionDTO';
import {
  InternalAuditCriteriaApplyDTO,
  InternalAuditCriteriaApplyResultDTO,
  InternalAuditCriteriaPreviewDTO,
  InternalAuditImprovementAnalysisDTO,
  InternalAuditImprovementApplyDTO,
  InternalAuditImprovementDTO,
  InternalAuditImprovementResultDTO,
  InternalAuditProcedureFromTasksDTO,
} from 'models/dto/internalAuditImprovementDTO';
import InternalAuditMonitoringUpgradePreviewDTO, {
  InternalAuditMonitoringSourceDTO,
  InternalAuditMonitoringUpgradeResultDTO,
} from 'models/dto/internalAuditMonitoringUpgradeDTO';
import { InternalAuditReportSettingsDTO } from 'models/dto/internalAuditReportSettingsDTO';
import InternalAuditScopeDTO, {
  InternalAuditScopeCandidateDTO,
  InternalAuditScopeIdsDTO,
  InternalAuditScopeIndexDTO,
  InternalAuditScopeItemDTO,
  InternalAuditScopeSuggestionDTO,
  InternalAuditScopeSuggestionsRequestDTO,
} from 'models/dto/internalAuditScopeDTO';
import InternalAuditTemplateDTO, { InternalAuditScheduleDTO } from 'models/dto/internalAuditTemplateDTO';
import ResourceLinkDTO from 'models/dto/resourceLinkDTO';
import TaskDTO from 'models/dto/tasks/taskDTO';
import TaskTypeFormElementDTO from 'models/dto/tasks/taskTypeFormElementDTO';
import TasksDTO from 'models/dto/tasks/tasksDTO';
import Entity, { EntityTypes } from 'models/entity';
import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import InternalAudit, {
  AuditMeetingAvailability,
  AuditStatus,
  InternalAuditSaveAsTemplateResult,
  InternalAuditUser,
} from 'models/internalAudit';
import {
  InternalAuditAiAuditReportLink,
  InternalAuditAiAuditStatus,
  InternalAuditConclusionSuggestion,
  InternalAuditControlAuditResult,
} from 'models/internalAuditAiAudit';
import {
  InternalAuditExecution,
  InternalAuditProcedureSuggestion,
  InternalAuditScopeAssessment,
  InternalAuditTaskExecution,
} from 'models/internalAuditExecution';
import {
  InternalAuditCriteriaApplyResult,
  InternalAuditCriteriaPreview,
  InternalAuditCriterionDraft,
  InternalAuditImprovement,
  InternalAuditImprovementAnalysis,
  InternalAuditImprovementProposal,
  InternalAuditImprovementResult,
} from 'models/internalAuditImprovement';
import InternalAuditMonitoringUpgradePreview, {
  InternalAuditMonitoringSource,
  InternalAuditMonitoringUpgradePreviewRequest,
  InternalAuditMonitoringUpgradeRequest,
  InternalAuditMonitoringUpgradeResult,
} from 'models/internalAuditMonitoringUpgrade';
import InternalAuditReportSettings from 'models/internalAuditReportSettings';
import {
  InternalAuditScope,
  InternalAuditScopeCandidate,
  InternalAuditScopeIndex,
  InternalAuditScopeSuggestion,
} from 'models/internalAuditScope';
import InternalAuditTemplate, { InternalAuditSchedule } from 'models/internalAuditTemplate';
import ResourceLink from 'models/resourceLink';
import Task from 'models/tasks/task';
import TaskTypeFormElement from 'models/tasks/taskTypeFormElement';
import Tasks from 'models/tasks/tasks';
import AppError from 'utils/appError';
import { toApiDateOptional, toApiDateTimeOptional, toApiDateTimeRequired } from 'utils/datetime';
import http from './httpService';

//
// Templates (audit series)
//

export async function apiPreviewInternalAuditMonitoringUpgrade(
  request: InternalAuditMonitoringUpgradePreviewRequest,
  accessToken: string,
): Promise<InternalAuditMonitoringUpgradePreview> {
  try {
    const dto = mapToInternalAuditMonitoringUpgradePreviewRequest(request);
    const res = await http.post<InternalAuditMonitoringUpgradePreviewDTO>(
      `/internalaudits/monitoringupgrade/preview`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditMonitoringUpgradePreview(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUpgradeMonitoringTasksToAudit(
  request: InternalAuditMonitoringUpgradeRequest,
  accessToken: string,
): Promise<InternalAuditMonitoringUpgradeResult> {
  try {
    const dto = mapToInternalAuditMonitoringUpgradeRequest(request);
    const res = await http.post<InternalAuditMonitoringUpgradeResultDTO>(
      `/internalaudits/monitoringupgrade`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditMonitoringUpgradeResult(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditMonitoringSources(
  internalAuditTemplateId: number,
  accessToken: string,
): Promise<InternalAuditMonitoringSource[]> {
  try {
    const res = await http.get<InternalAuditMonitoringSourceDTO[]>(
      `/internalaudits/templates/${internalAuditTemplateId}/monitoringsources`,
      http.getRequestConfig(accessToken),
    );

    return (res.data ?? []).map(mapFromInternalAuditMonitoringSource);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditTemplates(accessToken: string): Promise<InternalAuditTemplate[]> {
  try {
    const res = await http.get<InternalAuditTemplateDTO[]>(
      `/internalaudits/templates`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditTemplates(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditTemplate(
  id: number,
  accessToken: string,
): Promise<InternalAuditTemplate | undefined> {
  try {
    const res = await http.get<InternalAuditTemplateDTO>(
      `/internalaudits/templates/${id}`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditTemplate(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiAddInternalAuditTemplate(
  template: InternalAuditTemplate,
  accessToken: string,
): Promise<InternalAuditTemplate> {
  try {
    const dto = mapToInternalAuditTemplate(template);
    const res = await http.post<InternalAuditTemplateDTO>(
      `/internalaudits/templates`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditTemplate(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUpdateInternalAuditTemplate(
  template: InternalAuditTemplate,
  accessToken: string,
): Promise<InternalAuditTemplate> {
  try {
    const dto = mapToInternalAuditTemplate(template);
    const res = await http.put<InternalAuditTemplateDTO>(
      `/internalaudits/templates`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditTemplate(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiDeleteInternalAuditTemplate(id: number, accessToken: string): Promise<void> {
  try {
    await http.delete(`/internalaudits/templates/${id}`, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiCopyInternalAuditTemplate(id: number, accessToken: string): Promise<InternalAuditTemplate> {
  try {
    const res = await http.post<InternalAuditTemplateDTO>(
      `/internalaudits/templates/${id}/copy`,
      null,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditTemplate(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditSchedule(
  start: Date,
  end: Date,
  accessToken: string,
): Promise<InternalAuditSchedule[]> {
  try {
    const res = await http.get<InternalAuditScheduleDTO[]>(
      `/internalaudits/schedule?startDate=${toApiDateTimeRequired(start)}&endDate=${toApiDateTimeRequired(end)}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditSchedules(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//
// Occurrences (operational audits)
//

export async function apiGetInternalAudits(accessToken: string): Promise<InternalAudit[]> {
  try {
    const res = await http.get<InternalAuditDTO[]>(`/internalaudits`, http.getRequestConfig(accessToken));

    return mapFromInternalAudits(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetActiveInternalAuditsForUser(accessToken: string): Promise<InternalAudit[]> {
  try {
    const res = await http.get<InternalAuditDTO[]>(`/internalaudits/active`, http.getRequestConfig(accessToken));

    return mapFromInternalAudits(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//the audits that have this entity in their scope: read by the context of the entity itself
export async function apiGetInternalAuditsForEntity(
  entityType: EntityTypes,
  entityId: number,
  accessToken: string,
): Promise<InternalAudit[]> {
  try {
    const res = await http.get<InternalAuditDTO[]>(
      `/internalaudits/entity/${entityType}/${entityId}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAudits(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAudit(id: number, accessToken: string): Promise<InternalAudit | undefined> {
  try {
    const res = await http.get<InternalAuditDTO>(`/internalaudits/${id}`, http.getRequestConfig(accessToken));

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Creates an ad hoc occurrence of the series, outside the recurring pattern. The scope is copied
// from the latest occurrence.
export async function apiAddInternalAudit(
  templateId: number,
  audit: InternalAudit,
  accessToken: string,
): Promise<InternalAudit> {
  try {
    const dto = mapToInternalAudit(audit);
    const res = await http.post<InternalAuditDTO>(
      `/internalaudits?templateId=${templateId}`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUpdateInternalAudit(audit: InternalAudit, accessToken: string): Promise<InternalAudit> {
  try {
    const dto = mapToInternalAudit(audit);
    const res = await http.put<InternalAuditDTO>(`/internalaudits`, dto, http.getRequestConfig(accessToken));

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiDeleteInternalAudit(id: number, accessToken: string): Promise<void> {
  try {
    await http.delete(`/internalaudits/${id}`, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// The audit reports location with its check, and the folder of this audit once it entered Preparing.
export async function apiGetInternalAuditReportSettings(
  id: number,
  accessToken: string,
): Promise<InternalAuditReportSettings> {
  try {
    const res = await http.get<InternalAuditReportSettingsDTO>(
      `/internalaudits/${id}/report/settings`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditReportSettings(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiCreateInternalAuditReportDocument(
  id: number,
  regenerate: boolean,
  accessToken: string,
  cache: GlobalDataCache,
): Promise<ResourceLink | undefined> {
  try {
    await cache.lists.getItems(); //the link needs its list to resolve its preview
    const res = await http.post<ResourceLinkDTO>(
      `/internalaudits/${id}/report/document?regenerate=${regenerate}`,
      undefined,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromResourceLink(res.data, cache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Brings the report up to date with the audit's latest results while keeping the text and the
// comments the team put into it. The non-destructive counterpart of regenerating.
//
// Also answers with the points from those comments that the report could not take: the update
// rebuilds the document and the comment threads do not survive that, so a point that is not in the
// report has to be shown to the user or it is lost.
export async function apiUpdateInternalAuditReportDocument(
  id: number,
  accessToken: string,
  cache: GlobalDataCache,
): Promise<{ link: ResourceLink | undefined; unappliedComments: string[] }> {
  try {
    await cache.lists.getItems(); //the link needs its list to resolve its preview
    const res = await http.post<InternalAuditReportUpdateDTO>(
      `/internalaudits/${id}/report/document/update`,
      undefined,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return { link: undefined, unappliedComments: [] };

    return {
      link: res.data.link ? mapFromResourceLink(res.data.link, cache) : undefined,
      unappliedComments: res.data.unappliedComments ?? [],
    };
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// What the stored report document looks like right now. Asked just before regenerating, so the
// confirmation can name the changes it is about to replace instead of warning in the abstract.
export async function apiGetInternalAuditReportDocumentStatus(
  id: number,
  accessToken: string,
): Promise<InternalAuditReportDocumentStatusDTO | undefined> {
  try {
    const res = await http.get<InternalAuditReportDocumentStatusDTO>(
      `/internalaudits/${id}/report/document/status`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return res.data;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Replaces the whole scope of the audit in one call - what the scope picker saves. All families are
// always sent: an empty list clears that family. Documents here are the items in SCOPE; the ones
// merely attached to the audit have their own endpoint.
export async function apiSetInternalAuditScope(
  id: number,
  ids: InternalAuditScopeIdsDTO,
  accessToken: string,
): Promise<void> {
  try {
    await http.put(`/internalaudits/${id}/scope`, ids, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// The scope of every audit, reduced to the code and name of the items in it: what the audits list
// searches on. Audits with an empty scope are not in the response.
export async function apiGetInternalAuditScopes(accessToken: string): Promise<InternalAuditScopeIndex[]> {
  try {
    const res = await http.get<InternalAuditScopeIndexDTO[]>(
      `/internalaudits/scopes`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScopeIndex(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditScope(id: number, accessToken: string): Promise<InternalAuditScope> {
  try {
    const res = await http.get<InternalAuditScopeDTO>(
      `/internalaudits/${id}/scope`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScope(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditScopeCandidates(
  id: number,
  entityType: EntityTypes,
  suppliersOnly: boolean,
  accessToken: string,
): Promise<InternalAuditScopeCandidate[]> {
  try {
    const res = await http.get<InternalAuditScopeCandidateDTO[]>(
      `/internalaudits/${id}/scope/candidates?entityType=${entityType}&suppliersOnly=${suppliersOnly}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScopeCandidates(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Series-aware AI scope suggestions: the server analyses the scopes of the operational audits of
// the last 3 years plus the per-norm coverage instructions and suggests what this occurrence must
// still cover. The optional instructions steer the suggestion ("focus on cloud suppliers").
export async function apiGetInternalAuditScopeSuggestions(
  id: number,
  instructions: string | undefined,
  isoNormIds: number[],
  connectionId: string | null,
  accessToken: string,
): Promise<InternalAuditScopeSuggestion[]> {
  try {
    const dto = new InternalAuditScopeSuggestionsRequestDTO();
    dto.instructions = instructions;
    dto.isoNormIds = isoNormIds;
    const connectionQuery = connectionId ? `?connectionId=${encodeURIComponent(connectionId)}` : '';
    const res = await http.post<InternalAuditScopeSuggestionDTO[]>(
      `/internalaudits/${id}/scope/suggestions${connectionQuery}`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScopeSuggestions(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Preview of "add related items": every supported item related to the given scope item, one level
// deep, that is not in the scope yet. Read-only; the scope editor commits through the set endpoints.
export async function apiGetRelatedScopeItems(id: number, entity: Entity, accessToken: string): Promise<Entity[]> {
  try {
    const res = await http.get<InternalAuditScopeItemDTO[]>(
      `/internalaudits/${id}/scope/related?entityType=${entity.typeOfEntity}&entityId=${entity.entityId}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScopeItems(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//
// Template scope (the default scope of the series, edited from the audit list)
//

export async function apiGetInternalAuditTemplateScope(
  templateId: number,
  accessToken: string,
): Promise<InternalAuditScope> {
  try {
    const res = await http.get<InternalAuditScopeDTO>(
      `/internalaudits/templates/${templateId}/scope`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScope(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Replaces the whole default scope of the series in one call. All six families are always sent:
// an empty list clears that family.
export async function apiSetInternalAuditTemplateScope(
  templateId: number,
  ids: InternalAuditScopeIdsDTO,
  accessToken: string,
): Promise<void> {
  try {
    await http.put(`/internalaudits/templates/${templateId}/scope`, ids, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditTemplateScopeCandidates(
  templateId: number,
  entityType: EntityTypes,
  suppliersOnly: boolean,
  accessToken: string,
): Promise<InternalAuditScopeCandidate[]> {
  try {
    const res = await http.get<InternalAuditScopeCandidateDTO[]>(
      `/internalaudits/templates/${templateId}/scope/candidates?entityType=${entityType}&suppliersOnly=${suppliersOnly}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScopeCandidates(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetTemplateRelatedScopeItems(
  templateId: number,
  entity: Entity,
  accessToken: string,
): Promise<Entity[]> {
  try {
    const res = await http.get<InternalAuditScopeItemDTO[]>(
      `/internalaudits/templates/${templateId}/scope/related?entityType=${entity.typeOfEntity}&entityId=${entity.entityId}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditScopeItems(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiSetInternalAuditLinks(id: number, linkIds: number[], accessToken: string): Promise<void> {
  try {
    const body = new IdListDTO(linkIds.map((l) => l.toString()));
    await http.post(`/internalaudits/${id}/links`, body, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiSetInternalAuditScopeAssessment(
  id: number,
  entityType: number,
  entityId: number,
  assessment: InternalAuditAssessmentDTO,
  accessToken: string,
): Promise<InternalAuditScopeAssessment | undefined> {
  try {
    const res = await http.put<InternalAuditScopeAssessmentDTO>(
      `/internalaudits/${id}/scope/${entityType}/${entityId}/assessment`,
      assessment,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditScopeAssessment(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetPreviousInternalAuditScopeAssessment(
  id: number,
  entityType: number,
  entityId: number,
  accessToken: string,
): Promise<InternalAuditScopeAssessment | undefined> {
  try {
    const res = await http.get<InternalAuditScopeAssessmentDTO>(
      `/internalaudits/${id}/scope/${entityType}/${entityId}/previous`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditScopeAssessment(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditExecution(
  id: number,
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const res = await http.get<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/execution`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiAssignInternalAuditScopeItems(
  id: number,
  items: InternalAuditScopeItemKeyDTO[],
  userId: string,
  templateTaskId: number | undefined,
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const body = new InternalAuditExecutionAssignDTO();
    body.items = items;
    body.userId = userId;
    body.templateTaskId = templateTaskId;

    const res = await http.post<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/execution/assign`,
      body,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * How much follow-up work would lose its tie to the audit if the execution tasks of these items were
 * deleted. Ask before unassigning or removing items from the scope: a finding is a follow-up of the
 * task that found it, so deleting that task takes the finding off the audit.
 */
export async function apiGetInternalAuditFindingsPrecheck(
  id: number,
  items: InternalAuditScopeItemKeyDTO[],
  accessToken: string,
): Promise<InternalAuditFindingsPrecheckDTO | undefined> {
  try {
    const body = new InternalAuditExecutionItemsDTO();
    body.items = items;

    const res = await http.post<InternalAuditFindingsPrecheckDTO>(
      `/internalaudits/${id}/execution/findingsprecheck`,
      body,
      http.getRequestConfig(accessToken),
    );

    return res.data ?? undefined;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiUnassignInternalAuditScopeItems(
  id: number,
  items: InternalAuditScopeItemKeyDTO[],
  deleteFindings: boolean,
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const body = new InternalAuditExecutionItemsDTO();
    body.items = items;
    body.deleteFindings = deleteFindings;

    const res = await http.post<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/execution/unassign`,
      body,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiPlanInternalAuditScopeItems(
  id: number,
  items: InternalAuditScopeItemKeyDTO[],
  plannedOn: Date | undefined,
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const body = new InternalAuditExecutionPlanDTO();
    body.items = items;
    // a calendar date: the server stores it as UTC midnight and validates it against the audit period
    body.plannedOn = toApiDateOptional(plannedOn);

    const res = await http.post<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/execution/plan`,
      body,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiReorderInternalAuditScopeItems(
  id: number,
  items: InternalAuditExecutionOrderItemDTO[],
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const body = new InternalAuditExecutionReorderDTO();
    body.items = items;

    const res = await http.post<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/execution/reorder`,
      body,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiRemoveInternalAuditScopeItems(
  id: number,
  items: InternalAuditScopeItemKeyDTO[],
  deleteFindings: boolean,
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const body = new InternalAuditExecutionItemsDTO();
    body.items = items;
    body.deleteFindings = deleteFindings;

    const res = await http.post<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/scope/remove`,
      body,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Saves the setup of this audit (scope, procedure and default assignee per item, team) as the
// setup of its series. Allowed in any status - the audit itself is only read.
export async function apiUseInternalAuditAsTemplate(
  id: number,
  accessToken: string,
): Promise<InternalAuditSaveAsTemplateResult | undefined> {
  try {
    const res = await http.post<InternalAuditSaveAsTemplateResultDTO>(
      `/internalaudits/${id}/use-as-template`,
      null,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditSaveAsTemplateResult(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Throws the setup of this audit away and rebuilds it from its series. Only before the audit has
// started; later the server answers AUDIT0010.
export async function apiResetInternalAuditToTemplate(
  id: number,
  accessToken: string,
): Promise<InternalAuditExecution | undefined> {
  try {
    const res = await http.post<InternalAuditExecutionDTO>(
      `/internalaudits/${id}/reset-to-template`,
      null,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditProcedureSuggestions(
  id: number,
  accessToken: string,
): Promise<InternalAuditProcedureSuggestion[]> {
  try {
    const res = await http.post<InternalAuditProcedureSuggestionDTO[]>(
      `/internalaudits/${id}/execution/procedures/suggestions`,
      null,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditProcedureSuggestions(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditTaskExecution(
  taskId: number,
  accessToken: string,
): Promise<InternalAuditTaskExecution | undefined> {
  try {
    const res = await http.get<InternalAuditTaskExecutionDTO>(
      `/internalaudits/tasks/${taskId}/execution`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditTaskExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetReadableInternalAuditTask(
  internalAuditId: number,
  taskId: number,
  entityType: EntityTypes,
  entityId: number,
  accessToken: string,
  globalDataCache: GlobalDataCache,
): Promise<Task | undefined> {
  try {
    const res = await http.get<TasksDTO>(
      `/internalaudits/${internalAuditId}/tasks/${taskId}?entityType=${entityType}&entityId=${entityId}`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromTasks(res.data, globalDataCache).tasks[0];
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetReadableInternalAuditTaskForm(
  internalAuditId: number,
  taskId: number,
  entityType: EntityTypes,
  entityId: number,
  accessToken: string,
): Promise<TaskTypeFormElement[]> {
  try {
    const res = await http.get<TaskTypeFormElementDTO[]>(
      `/internalaudits/${internalAuditId}/tasks/${taskId}/form?entityType=${entityType}&entityId=${entityId}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromTaskTypeForm(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditTaskNavigation(
  taskId: number,
  accessToken: string,
): Promise<InternalAuditTaskNavigationDTO | undefined> {
  try {
    const res = await http.get<InternalAuditTaskNavigationDTO>(
      `/internalaudits/tasks/${taskId}/navigation`,
      http.getRequestConfig(accessToken),
    );

    return res.data ?? undefined;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiSetInternalAuditTaskResult(
  taskId: number,
  outcome: number,
  conclusion: string | undefined,
  accessToken: string,
  fromAiAudit?: boolean,
): Promise<InternalAuditTaskExecution | undefined> {
  try {
    const body = new InternalAuditTaskResultDTO();
    body.outcome = outcome;
    body.conclusion = conclusion;
    body.fromAiAudit = fromAiAudit === true;

    const res = await http.put<InternalAuditTaskExecutionDTO>(
      `/internalaudits/tasks/${taskId}/result`,
      body,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAuditTaskExecution(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// A finding is raised by relating a task to the execution task it follows up on (apiAddTaskRelation),
// which needs no audit-level permission - the auditee who did the work can do it. There is no "link a
// task to an audit" call: an audit link means the task IS the audit's execution work, which only the
// audit writes. DELETE internalaudits/{id}/tasks/{taskId} takes a finding back off the audit.

/**
 * What this audit says about the procedures it was done with: the remarks the auditors wrote beside
 * the questions, and the execution work that has no procedure behind it yet.
 */
export async function apiGetInternalAuditImprovement(
  id: number,
  accessToken: string,
): Promise<InternalAuditImprovement> {
  try {
    const res = await http.get<InternalAuditImprovementDTO>(
      `/internalaudits/${id}/improvement`,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditImprovement(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Asks AI which of the remarks are about the procedures rather than about this one audit. Nothing is
 * stored server-side: the proposals live here until something is done with them.
 */
export async function apiAnalyzeInternalAuditImprovements(
  id: number,
  accessToken: string,
): Promise<InternalAuditImprovementAnalysis> {
  try {
    const res = await http.post<InternalAuditImprovementAnalysisDTO>(
      `/internalaudits/${id}/improvement/analyze`,
      null,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditImprovementAnalysis(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Drafts the audit-criterion changes the picked remarks ask for: one editable before/after per
 * criterion, nothing written. The server decides which criterion a remark is about from its own
 * comments; the posted identity is only the (task, KPI) pair of each remark.
 */
export async function apiPreviewInternalAuditCriteriaImprovements(
  id: number,
  proposals: InternalAuditImprovementProposal[],
  accessToken: string,
): Promise<InternalAuditCriteriaPreview> {
  try {
    const body = new InternalAuditImprovementApplyDTO();
    body.proposals = proposals.map((proposal) => mapToInternalAuditImprovementProposal(proposal));

    const res = await http.post<InternalAuditCriteriaPreviewDTO>(
      `/internalaudits/${id}/improvement/criteria/preview`,
      body,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditCriteriaPreview(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Writes the approved drafts into the criteria sets of the audited items, texts as the lead auditor
 * left them. All or nothing: a criterion that changed since the preview refuses the request with
 * AUDIT0028 (Code_InternalAudit_CriteriaChanged).
 */
export async function apiApplyInternalAuditCriteriaImprovements(
  id: number,
  drafts: InternalAuditCriterionDraft[],
  accessToken: string,
): Promise<InternalAuditCriteriaApplyResult> {
  try {
    const body = new InternalAuditCriteriaApplyDTO();
    body.drafts = drafts.map((draft) => mapToInternalAuditCriterionDraft(draft));

    const res = await http.post<InternalAuditCriteriaApplyResultDTO>(
      `/internalaudits/${id}/improvement/criteria/apply`,
      body,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditCriteriaApplyResult(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Writes the picked recommendations down as one task for the lead auditor.
 */
export async function apiCreateInternalAuditImprovementTask(
  id: number,
  proposals: InternalAuditImprovementProposal[],
  accessToken: string,
): Promise<InternalAuditImprovementResult> {
  try {
    const body = new InternalAuditImprovementApplyDTO();
    body.proposals = proposals.map((proposal) => mapToInternalAuditImprovementProposal(proposal));

    const res = await http.post<InternalAuditImprovementResultDTO>(
      `/internalaudits/${id}/improvement/task`,
      body,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditImprovementResult(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Keeps the picked execution tasks as procedures of the library.
 */
export async function apiCreateProceduresFromAuditTasks(
  id: number,
  taskIds: number[],
  accessToken: string,
): Promise<InternalAuditImprovementResult> {
  try {
    const body = new InternalAuditProcedureFromTasksDTO();
    body.taskIds = taskIds;

    const res = await http.post<InternalAuditImprovementResultDTO>(
      `/internalaudits/${id}/improvement/procedures`,
      body,
      http.getRequestConfig(accessToken),
    );

    return mapFromInternalAuditImprovementResult(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * The procedure library of this organization: the event template whose subtasks are the audit
 * procedures. One library for the whole organization; it is created on the first call.
 */
export async function apiGetAuditProcedureLibrary(
  accessToken: string,
  globalDataCache: GlobalDataCache,
): Promise<Task | undefined> {
  try {
    const res = await http.get<TaskDTO>(`/internalaudits/procedurelibrary`, http.getRequestConfig(accessToken));

    if (!res.data) return undefined;

    return mapFromTask(res.data, globalDataCache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * The id of the library procedure already carrying this name, or undefined when the name is free.
 * Read-only: unlike apiGetAuditProcedureLibrary it never creates the library.
 */
export async function apiGetAuditProcedureName(name: string, accessToken: string): Promise<number | undefined> {
  try {
    const res = await http.post<number | null>(
      `/internalaudits/procedures/name`,
      { valueString: name },
      http.getRequestConfig(accessToken),
    );

    return Number(res.data) || undefined;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiFinishInternalAudit(id: number, accessToken: string): Promise<InternalAudit | undefined> {
  try {
    const res = await http.post<InternalAuditDTO>(
      `/internalaudits/${id}/finish`,
      null,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiPublishInternalAudit(id: number, accessToken: string): Promise<InternalAudit | undefined> {
  try {
    const res = await http.post<InternalAuditDTO>(
      `/internalaudits/${id}/publish`,
      null,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Tasks of an audit. With excludeExecution the server leaves out the audit's own execution work,
 * so only the findings remain. The filter cannot be applied on the client: the relation type on a
 * task reports the execution link first when a task is execution work of one audit and a finding
 * of another.
 */
export async function apiGetTasksForInternalAudit(
  id: number,
  start: Date | undefined,
  end: Date | undefined,
  excludeExecution: boolean,
  accessToken: string,
  globalDataCache: GlobalDataCache,
): Promise<Tasks> {
  try {
    const params: string[] = [];
    if (start) params.push(`start=${toApiDateTimeOptional(start)}`);
    if (end) params.push(`end=${toApiDateTimeOptional(end)}`);
    if (excludeExecution) params.push('excludeExecution=true');

    let url = `/tasks/internalaudit/${id}`;
    if (params.length > 0) url += `?${params.join('&')}`;

    const res = await http.get<TasksDTO>(url, http.getRequestConfig(accessToken));

    return mapFromTasks(res.data, globalDataCache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetTasksForInternalAuditViewSchedule(
  id: number,
  start: Date,
  end: Date,
  excludeExecution: boolean,
  accessToken: string,
  globalDataCache: GlobalDataCache,
): Promise<Tasks> {
  try {
    let url = `/tasks/internalaudit/${id}/schedule?startDate=${toApiDateTimeRequired(
      start,
    )}&endDate=${toApiDateTimeRequired(end)}`;
    if (excludeExecution) url += '&excludeExecution=true';

    const res = await http.get<TasksDTO>(url, http.getRequestConfig(accessToken));

    return mapFromTasks(res.data, globalDataCache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetLinksForInternalAudit(
  id: number,
  accessToken: string,
  cache: GlobalDataCache,
): Promise<ResourceLink[]> {
  try {
    const res = await http.get<ResourceLinkDTO[]>(`/links/internalaudit/${id}`, http.getRequestConfig(accessToken));
    await cache.lists.getItems();

    return mapFromResourceLinks(res.data, cache);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiAddLinkToInternalAudit(linkId: number, id: number, accessToken: string): Promise<void> {
  try {
    const body = new InternalAuditLinkDTO();
    body.internalAuditId = id;
    body.linkId = linkId;

    await http.post(`/links/internalaudit?add=${true}`, body, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiRemoveLinkFromInternalAudit(
  link: ResourceLink,
  id: number,
  accessToken: string,
): Promise<void> {
  try {
    const body = new InternalAuditLinkDTO();
    body.internalAuditId = id;
    body.linkId = link.linkId;

    await http.post(`/links/internalaudit?add=${false}`, body, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditTransition(
  id: number,
  target: AuditStatus,
  accessToken: string,
): Promise<InternalAuditTransitionDTO | undefined> {
  try {
    const res = await http.get<InternalAuditTransitionDTO>(
      `/internalaudits/${id}/transition?target=${target}`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    res.data.warnings = res.data.warnings ?? [];
    res.data.teamPermissionIssues = res.data.teamPermissionIssues ?? [];

    return res.data;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

// Whether every member of a - possibly unsaved - audit team can act in the role they were given.
// A POST because the team it judges does not have to exist yet, and it is not keyed on an audit:
// the occurrence, the series template and the add-series panel all ask the same question.
export async function apiCheckInternalAuditTeamPermissions(
  authSchemaId: number | undefined,
  participants: InternalAuditUser[],
  accessToken: string,
): Promise<InternalAuditTeamPermissionDTO[]> {
  try {
    const dto = new InternalAuditTeamPermissionRequestDTO();
    dto.authSchemaId = authSchemaId;
    dto.participants = mapToInternalAuditUsers(participants);

    const res = await http.post<InternalAuditTeamPermissionDTO[]>(
      `/internalaudits/team/permissioncheck`,
      dto,
      http.getRequestConfig(accessToken),
    );

    return res.data ?? [];
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiSetInternalAuditStatus(
  id: number,
  status: AuditStatus,
  accessToken: string,
  // confirmation for the Completed step: delete the open execution tasks without an auditee
  deleteUnassignedTasks?: boolean,
): Promise<InternalAudit | undefined> {
  try {
    const res = await http.post<InternalAuditDTO>(
      `/internalaudits/${id}/status`,
      { status, deleteUnassignedTasks: deleteUnassignedTasks === true },
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiCreateOrUpdateInternalAuditMeeting(
  id: number,
  accessToken: string,
): Promise<InternalAudit | undefined> {
  try {
    const res = await http.post<InternalAuditDTO>(
      `/internalaudits/${id}/meeting`,
      null,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiRemoveInternalAuditMeeting(
  id: number,
  accessToken: string,
): Promise<InternalAudit | undefined> {
  try {
    const res = await http.delete<InternalAuditDTO>(
      `/internalaudits/${id}/meeting`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditMeetingAvailability(
  id: number,
  start: Date | undefined,
  end: Date | undefined,
  accessToken: string,
): Promise<AuditMeetingAvailability | undefined> {
  try {
    // without a slot the server evaluates the saved meeting moment
    const params = new URLSearchParams();
    const startParam = toApiDateTimeOptional(start);
    const endParam = toApiDateTimeOptional(end);
    if (startParam) params.append('start', startParam);
    if (endParam) params.append('end', endParam);
    const query = params.toString();

    const res = await http.get<InternalAuditMeetingAvailabilityDTO>(
      `/internalaudits/${id}/meeting/availability${query ? `?${query}` : ''}`,
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromAuditMeetingAvailability(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiSendInternalAuditInvitations(
  id: number,
  final: boolean,
  accessToken: string,
): Promise<InternalAudit | undefined> {
  try {
    const res = await http.post<InternalAuditDTO>(
      `/internalaudits/${id}/invitations`,
      { final },
      http.getRequestConfig(accessToken),
    );

    if (!res.data) return undefined;

    return mapFromInternalAudit(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiSendInternalAuditReport(id: number, accessToken: string): Promise<number> {
  try {
    const res = await http.post<{ recipientCount?: number }>(
      `/internalaudits/${id}/report/send`,
      null,
      http.getRequestConfig(accessToken),
    );

    return res.data?.recipientCount ?? 0;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiDownloadInternalAuditReport(id: number, accessToken: string): Promise<Blob> {
  try {
    const config = { ...http.getRequestConfig(accessToken), responseType: 'blob' as const };
    const res = await http.get<Blob>(`/internalaudits/${id}/report`, config);

    return res.data;
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//
// AI control audit: one unattended run per audit over its Control/Requirement scope items.
// Preparation happens inside the start request (it needs the user's token); after that the run
// finishes on its own and the tab only polls the status.
//

export async function apiStartInternalAuditAiAudit(
  id: number,
  body: InternalAuditAiAuditStartDTO,
  accessToken: string,
): Promise<InternalAuditAiAuditStatus | undefined> {
  try {
    const res = await http.post<InternalAuditAiAuditStatusDTO>(
      `/internalaudits/${id}/aiaudit/start`,
      body,
      http.getRequestConfig(accessToken),
    );
    if (!res.data) return undefined;

    return mapFromInternalAuditAiAuditStatus(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiStopInternalAuditAiAudit(
  id: number,
  accessToken: string,
): Promise<InternalAuditAiAuditStatus | undefined> {
  try {
    const res = await http.post<InternalAuditAiAuditStatusDTO>(
      `/internalaudits/${id}/aiaudit/stop`,
      {},
      http.getRequestConfig(accessToken),
    );
    if (!res.data) return undefined;

    return mapFromInternalAuditAiAuditStatus(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiClearInternalAuditAiAudit(
  id: number,
  items: InternalAuditScopeItemKeyDTO[],
  accessToken: string,
): Promise<InternalAuditAiAuditStatus | undefined> {
  try {
    const res = await http.post<InternalAuditAiAuditStatusDTO>(
      `/internalaudits/${id}/aiaudit/clear`,
      { items: items },
      http.getRequestConfig(accessToken),
    );
    if (!res.data) return undefined;

    return mapFromInternalAuditAiAuditStatus(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiGetInternalAuditAiAudit(
  id: number,
  accessToken: string,
): Promise<InternalAuditAiAuditStatus | undefined> {
  try {
    const res = await http.get<InternalAuditAiAuditStatusDTO>(
      `/internalaudits/${id}/aiaudit`,
      http.getRequestConfig(accessToken),
    );
    if (!res.data) return undefined;

    return mapFromInternalAuditAiAuditStatus(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * The AI results of the items an execution task covers, for the auditee's task pane. Task-scoped
 * authorization: assignment is the grant, like the execution read model.
 */
export async function apiGetInternalAuditTaskAiAudit(
  taskId: number,
  accessToken: string,
): Promise<InternalAuditControlAuditResult[]> {
  try {
    const res = await http.get<InternalAuditControlAuditResultDTO[]>(
      `/internalaudits/tasks/${taskId}/aiaudit`,
      http.getRequestConfig(accessToken),
    );

    return (res.data ?? []).map(mapFromInternalAuditControlAuditResult);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Suggests the outcome and conclusion of one execution task from what the auditor recorded. No body:
 * the caller flushes its autosave first, so the stored task is the current state.
 *
 * Returns undefined when nothing came back, for any reason. The caller shows one message for all of
 * them and leaves the editor alone.
 */
export async function apiSuggestInternalAuditTaskConclusion(
  taskId: number,
  accessToken: string,
): Promise<InternalAuditConclusionSuggestion | undefined> {
  try {
    const res = await http.post<InternalAuditConclusionSuggestionDTO>(
      `/internalaudits/tasks/${taskId}/result/suggestion`,
      {},
      http.getRequestConfig(accessToken),
    );
    if (!res.data) return undefined;

    return mapFromInternalAuditConclusionSuggestion(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/**
 * Renders the AI report of one covered control to DOCX in the audit's report library and attaches
 * it to both the execution task and the audited Control/Requirement. Idempotent; a re-run's report
 * becomes a new version of the same document.
 */
export async function apiCreateInternalAuditTaskAiAuditReport(
  taskId: number,
  controlId: number,
  accessToken: string,
): Promise<InternalAuditAiAuditReportLink | undefined> {
  try {
    const res = await http.post<InternalAuditAiAuditReportLinkDTO>(
      `/internalaudits/tasks/${taskId}/aiaudit/${controlId}/report`,
      {},
      http.getRequestConfig(accessToken),
    );
    if (!res.data) return undefined;

    return mapFromInternalAuditAiAuditReportLink(res.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
